'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var MAX_DEPTH = 2; // Lib

exports.default = function (event, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    var editorState = getEditorState();
    var updatedState = _draftJs.RichUtils.onTab(event, editorState, MAX_DEPTH);

    if (updatedState !== editorState) {
        setEditorState(updatedState);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/editingHelper/onTab.js
// module id = 1732
// module chunks = 0